import { AppType } from "@shared/types/app.types";
import { apiRequest } from "@shared/services/api/apiRequest";
import { useQuery } from "@tanstack/react-query";

export const useGetUserDataQuery = (
  appName: AppType,
  normalizeDataFunction: (data: any) => any = (data) => data,
  isEnabled = true,
  refetchOnWindowFocus = true,
  refetchOnReconnect = true
) => {
  const method = appName === "portal" ? "GET" : "POST";

  return useQuery({
    queryKey: ["portal-user"],
    queryFn: async () => {
      return apiRequest("/api/fetch-all-user-data/", method);
    },
    select: normalizeDataFunction,
    retry: false,
    enabled: isEnabled,
    refetchOnWindowFocus: refetchOnWindowFocus,
    refetchOnReconnect: refetchOnReconnect,
  });
};

export default useGetUserDataQuery;
